import { render, staticRenderFns } from "./UniversalSearch.vue?vue&type=template&id=7d4c26f2&scoped=true"
import script from "./UniversalSearch.vue?vue&type=script&lang=js"
export * from "./UniversalSearch.vue?vue&type=script&lang=js"
import style0 from "./UniversalSearch.vue?vue&type=style&index=0&id=7d4c26f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c26f2",
  null
  
)

export default component.exports